import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../redux/store";
import { fetchEditPassword } from "../../../redux/profile/settings/changeDataProfile/asyncActions";
import { Button } from "../../../components";
import { Modal } from "../../../components";
import styles from "./ChangePasswordScreen.module.scss";

import openEyeIcon from "../../../assets/icons/openEye.svg";
import closeEyeIcon from "../../../assets/icons/closeEye.svg";

export const ChangePasswordScreen: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [newPassword, setNewPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [error, setError] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showRepeatPassword, setShowRepeatPassword] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const isValid = newPassword.length >= 6 && newPassword === repeatPassword;

  const handleSave = async () => {
    if (!isValid) {
      setError("Пароли не совпадают или слишком короткие");
      return;
    }

    try {
      const result = await dispatch(fetchEditPassword({ password: newPassword }));
      
      if (result.payload === 200) {
        setShowSuccessModal(true);
      } else {
        setError("Ошибка при смене пароля. Попробуйте снова.");
      }
    } catch (err) {
      setError("Ошибка при смене пароля. Попробуйте снова.");
    }
  };

  const handleSuccessModalClose = () => {
    setShowSuccessModal(false);
    navigate(-1);
  };

  return (
    <div className={styles.container}>
      <div className={styles.formContainer}>
        {/* Поле Новый пароль */}
        <div className={styles.inputGroup}>
          <label className={styles.label}>Новый пароль</label>
          <div className={styles.inputWrapper}>
            <input
              type={showNewPassword ? "text" : "password"}
              className={styles.input}
              value={newPassword}
              onChange={(e) => {
                setNewPassword(e.target.value);
                setError("");
              }}
              placeholder="Новый пароль"
            />
            <button
              type="button"
              className={styles.eyeButton}
              onClick={() => setShowNewPassword(!showNewPassword)}
            >
              <img
                src={showNewPassword ? openEyeIcon : closeEyeIcon}
                alt={showNewPassword ? "Скрыть" : "Показать"}
                className={styles.eyeIcon}
              />
            </button>
          </div>
        </div>

        {/* Поле Повторите пароль */}
        <div className={styles.inputGroup}>
          <label className={styles.label}>Повторите пароль</label>
          <div className={styles.inputWrapper}>
            <input
              type={showRepeatPassword ? "text" : "password"}
              className={styles.input}
              value={repeatPassword}
              onChange={(e) => {
                setRepeatPassword(e.target.value);
                setError("");
              }}
              placeholder="Повторите пароль"
            />
            <button
              type="button"
              className={styles.eyeButton}
              onClick={() => setShowRepeatPassword(!showRepeatPassword)}
            >
              <img
                src={showRepeatPassword ? openEyeIcon : closeEyeIcon}
                alt={showRepeatPassword ? "Скрыть" : "Показать"}
                className={styles.eyeIcon}
              />
            </button>
          </div>
        </div>

        {/* Сообщение об ошибке */}
        {error && (
          <div className={styles.error}>{error}</div>
        )}

        {/* Подсказка */}
        {!error && (
          <div className={styles.hint}>
            Пароль должен содержать минимум 6 символов
          </div>
        )}
      </div>

      {/* Кнопка сохранения */}
      <div className={styles.buttonContainer}>
        <Button
          onClickFunc={handleSave}
          newStyles={isValid ? styles.saveButton : styles.disabledButton}
        >
          Сохранить
        </Button>
      </div>

      {/* Модальное окно успеха */}
      {showSuccessModal && (
        <Modal
          title="Пароль успешно изменен"
          isOpen={showSuccessModal}
          setIsOpen={setShowSuccessModal}
          subTitle=""
        >
          <div className={styles.modalButtons}>
            <Button onClickFunc={handleSuccessModalClose}>Продолжить</Button>
          </div>
        </Modal>
      )}
    </div>
  );
};

